import axios from "axios";
import { useMemo, useRef } from "react";
import { useAuth } from "@clerk/react";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const responderUrl = (token, s = "qr") => `${BACKEND}/api/r/${token}?s=${s}`;

export function useApi() {
  const { getToken } = useAuth();
  const ref = useRef(getToken);
  ref.current = getToken;
  return useMemo(() => {
    const c = axios.create({ baseURL: API });
    c.interceptors.request.use(async (cfg) => {
      const t = await ref.current();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      const d = localStorage.getItem("bsafe_device");
      if (d) cfg.headers["X-Bsafe-Device"] = d;
      return cfg;
    });
    c.interceptors.response.use((r) => r, (e) => {
      if (e?.response?.status === 401 && e.response.data?.detail === "mfa_required") window.dispatchEvent(new Event("bsafe-mfa"));
      return Promise.reject(e);
    });
    return c;
  }, []);
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.message || "Something went wrong";
};

export const fmtMoney = (n, cur) => `${cur} ${Number(n || 0).toLocaleString()}`;
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "—");
